import store from '../Redux/store'

let pool = []

export default class Api{

    static post(url, body, secured = true, contentType = 'application/json'){
        const state = store.getState()
        const headers = {}
        if(contentType)
            headers['Content-Type'] = contentType

        if(secured){
            const result = this.tokenCheckAndRefresh('post', url, body, secured, contentType)
            if (result)
                return result
            headers['Authorization'] = 'Bearer ' + state.app.global.authToken
        }

        let newBody = body
        if(contentType === 'application/json'){
            newBody = JSON.stringify(body)
        }
        
        return new Promise((res, rej) => {

            fetch(url, {
                method: 'POST',
                headers,
                body: newBody
            })
            .then(response => {
                return response.json()
            })
            .then(json => {
                res(json)
            })
            .catch(e => {
                rej(e)
            })
        })
    }

    static put(url, body, secured = true, contentType = 'application/json'){
        const state = store.getState()
        const headers = {}
        if(contentType)
            headers['Content-Type'] = contentType

        if(secured){
            const result = this.tokenCheckAndRefresh('put', url, body, secured, contentType)
            if (result)
                return result
            headers['Authorization'] = 'Bearer ' + state.app.global.authToken
        }

        let newBody = body
        if(contentType === 'application/json'){
            newBody = JSON.stringify(body)
        }

        return new Promise((res, rej) => {

            fetch(url, {
                method: 'PUT',
                headers,
                body: newBody
            })
            .then(response => {
                return response.json()
            })
            .then(json => {
                res(json)
            })
            .catch(e => {
                rej(e)
            })
        })
    }

    static get(url, body, secured = true, contentType = 'application/json'){
        const state = store.getState()
        const headers = {
            // 'Content-Type': 'application/json',
        }

        if(secured){
            const result = this.tokenCheckAndRefresh('get', url, body, secured, contentType)
            if (result)
                return result
            headers['Authorization'] = 'Bearer ' + state.app.global.authToken
        }

        return new Promise((res, rej) => {

            // let params = ""
            var params = "?";
            if(body){
                for (var key in body) {
                    if (params !== "?") {
                        params += "&";
                    }
                    params += key + "=" + encodeURIComponent(body[key]);
                }
            }

            fetch(url + params, {
                method: 'GET',
                headers,
                // body: JSON.stringify(body)
            })
            .then(response => {
                return response.json()
            })
            .then(json => {
                res(json)
            })
            .catch(e => {
                rej(e)
            })
        })
    }

    static delete(url, body, secured = true, contentType = 'application/json'){
        const state = store.getState()
        const headers = {
            // 'Content-Type': 'application/json',
        }

        if(secured){
            const result = this.tokenCheckAndRefresh('delete', url, body, secured, contentType)
            if (result)
                return result
            headers['Authorization'] = 'Bearer ' + state.app.global.authToken
        }

        return new Promise((res, rej) => {

            fetch(url, {
                method: 'DELETE',
                headers,
                // body: JSON.stringify(body)
            })
            .then(response => {
                return response.json()
            })
            .then(json => {
                res(json)
            })
            .catch(e => {
                rej(e)
            })
        })
    }

    // static tokenCheckAndRefresh(type, url, body = null, secured=true, contentType = 'application/json'){
    //     const state = store.getState()

    //     // si el token de autorizacion expiro, lo refresqueteo
    //     if(state.app.global.user && this.is_auth_token_expired(state.app.global.user.exp)){
    //         is_refreshing = true
            
    //         fetch(this.getApiBaseUrl() + 'api/auth/refreshToken', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify({
    //                 refreshToken: state.app.global.refreshToken
    //             })
    //         })
    //         .then(response => {
    //             return response.json()
    //         })
    //         .then(json => {
    //             delete json.success
    //             const user = jwt_decode(json.authToken)
    //             const payload = {
    //                 ...json,
    //                 user
    //             }
    //             store.dispatch(updateAuthToken(payload))
    //         })
    //         .catch(e => {
    //             console.log('bateo refreshing token');
    //             pool = []
    //             store.dispatch(logoutAction())
    //         })
    //         .finally(() => {
    //             is_refreshing = false
    //             this.process_pool()
    //         })
            
    //     }

    //     // si se esta actualizando el token, pongo a las peticiones en cola
    //     if(is_refreshing){
    //         return new Promise((res, rej) => {
    //             pool.push({
    //                 type,
    //                 url,
    //                 body,
    //                 secured,
    //                 contentType,
    //                 res,
    //                 rej
    //             })
    //         })
    //     }

    //     return false
    // }

    static is_auth_token_expired(exp_timestamp){
        const exp_time = new Date(exp_timestamp * 1000)
        return new Date() > exp_time
    }

    static process_pool(){
        for (const e of pool) {
            switch(e.type){
                case 'post':
                    this.post(e.url, e.body, e.secured, e.contentType)
                    .then(result => {
                        e.res(result)
                    })
                    .catch(error => {
                        e.rej(error)
                    })
                    break;
                case 'get':
                    this.get(e.url, e.body, e.secured, e.contentType)
                    .then(result => {
                        e.res(result)
                    })
                    .catch(error => {
                        e.rej(error)
                    })
                    break;
                case 'put':
                    this.put(e.url, e.body, e.secured, e.contentType)
                    .then(result => {
                        e.res(result)
                    })
                    .catch(error => {
                        e.rej(error)
                    })
                    break;
                case 'delete':
                    this.delete(e.url, e.body, e.secured, e.contentType)
                    .then(result => {
                        e.res(result)
                    })
                    .catch(error => {
                        e.rej(error)
                    })
                    break;
                default:
            }
        }

        pool = []
    } 

    static getApiBaseUrl(){
        const r = RegExp('(.+)\\.[^.]+\\.[^.]+$', 'g').exec(window.location.hostname)
        let url = process.env.REACT_APP_API_PROTOCOL + '://'
        if(r && r.length === 2){
            return url + r[1] + '.' + process.env.REACT_APP_API_HOSTNAME + '/'
        }
        return url + process.env.REACT_APP_API_HOSTNAME + '/'
    }
}